<template>
  <div>
    <PayLoan />
  </div>
</template>

<script>
import { mapState } from "vuex";

import PayLoan from "@/components/dashboard/pages/pay/PayLoan.vue";

export default {
  name: "PayLoanPage",

  components: { PayLoan },

  metaInfo: {
    meta: [
      {
        name: "facebook-domain-verification",
        content: process.env.VUE_APP_FACEBOOK_DOMAIN_VERIFICATION,
      },
    ],
  },

  data() {
    return {};
  },

  computed: {
    ...mapState({
      auth: "auth",
    }),
  },

  created() {
    if (!this.auth.user.open_application.can_sign_agreement) {
      this.$router.push({ name: "DashboardMyLoanPage" });
    } else if (this.auth.user.open_application.has_signed_agreement) {
      this.$router.push({ name: "DashboardDebitOrderApprovalPage" });
    }
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped>
//
</style>
